import { defineMessages } from "react-intl";

export const messages = defineMessages({
  addNewValue: {
    id: "U2WgwW",
    defaultMessage: "Add new value: {value}",
    description: "add custom select input option",
  },
});
